import { Trans } from '@lingui/macro'
import EarnIcon from 'components/icons/EarnIcon'
import useRToken from 'hooks/useRToken'
import { atom, useAtomValue } from 'jotai'
import { selectedRTokenAtom } from 'state/atoms'
import { poolsAtom } from 'state/pools/atoms'
import { Box, Text } from 'theme-ui'
import PoolsTable from 'views/earn/components/pools-table'

const rTokenPoolsAtom = atom((get) => {
  const pools = get(poolsAtom)
  const rToken = get(selectedRTokenAtom)

  if (!rToken) {
    return []
  }

  return pools.filter((pool) => {
    if (
      !pool.underlyingTokens.find(
        (token) => token.address.toLowerCase() === rToken.toLowerCase()
      )
    ) {
      return false
    }

    return true
  })
})

const RTokenEarn = () => {
  const data = useAtomValue(rTokenPoolsAtom)
  const rToken = useRToken()

  return (
    <Box>
      <Box
        variant="layout.verticalAlign"
        ml="4"
        mb={4}
        mt={6}
        sx={{ color: 'accent' }}
      >
        <EarnIcon fontSize={24} />
        <Text ml="2" as="h2" variant="title" sx={{ fontWeight: '400' }}>
          <Trans>Explore yield opportunities for {rToken?.symbol ?? ''}</Trans>
        </Text>
      </Box>
      <div className="overflow-auto">
        <PoolsTable compact data={data} />
      </div>
    </Box>
  )
}

export default RTokenEarn
